import { LiveData, Service } from '@toeverything/infra';

export class RowDetailModalController extends Service {
  readonly openRowId$ = new LiveData<string | null>(null);

  open(rowId: string): void {
    this.openRowId$.next(rowId);
  }

  close(): void {
    this.openRowId$.next(null);
  }
}
